import { CircularProgress } from '@mui/material';
import DetailSearchDataTable from 'app/components/DataTable/detailSearch/DetailSearchDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';

const DetailSearchPage = () => {


    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {

            } catch (error) {
                console.error("Error in API call:", error);
            }
            setLoading(false);
        };
        getAPI();
    }, []);


    const tableCellStyle = {};
    const commonColumnStyle = { ...tableCellStyle, minWidth: 30, maxWidth: 50 };

    const columnData = [

        { id: 'inst', align: 'left', disablePadding: false, label: "Toplantı", sx: { ...tableCellStyle, maxWidth: 70 } },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Tarih/Sayı", sx: commonColumnStyle },
        { id: 'decisionNo', align: 'left', disablePadding: false, label: "Karar No", sx: commonColumnStyle },
        // { id: 'meetingDate', align: 'left', disablePadding: false, label: "Tarih", sx: commonColumnStyle },
        { id: 'department', align: 'left', disablePadding: false, label: "İlgili Kurum/Birim", sx: commonColumnStyle },
        { id: 'subject', align: 'left', disablePadding: false, label: "Konu", sx: { ...tableCellStyle, maxWidth: 50 } },
        { id: 'agenda', align: 'left', disablePadding: false, label: "Gündem", sx: { ...tableCellStyle, minWidth: 300, maxWidth: 350 } },
        { id: 'decision', align: 'left', disablePadding: false, label: "Karar", sx: { ...tableCellStyle, minWidth: 300, maxWidth: 350 } },

        { id: 'status', align: 'left', disablePadding: false, label: "Ekli Dosyalar", sx: { ...tableCellStyle, minWidth: 50, maxWidth: 50 } },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler", sx: { ...tableCellStyle, minWidth: 80, maxWidth: 100 } }
    ];

    return (
        <React.Fragment>
            {/* <>
                <LoadingPopUp open={loading} />
                {!loading && <DetailSearchDataTable mainData={[]} column={columnData} />}
            </> */}

            <DetailSearchDataTable mainData={[]} column={columnData} />
        </React.Fragment>
    );
};

export default DetailSearchPage;